<nav class="navbar navbar-expand-lg px-0 topbar">
  <div class="collapse navbar-collapse">
    @if (settings?.is_demo_enabled) {
      <div class="v-text-primary small"><i class="lnr lnr-warning me-2" aria-hidden="true"></i><span>{{ 'TOPBAR.DEMO.PART1' | translate }}</span><a class="fw-bold v-text-primary" [href]="billingUrl" target="_blank">{{ 'TOPBAR.DEMO.CTA1' | translate }}</a><span>{{ 'TOPBAR.DEMO.PART2' | translate }}</span><a class="fw-bold v-text-primary" href="https://calendly.com/vitay/vitay_demo" target="_blank" rel="noopener noreferrer">{{ 'TOPBAR.DEMO.CTA2' | translate }}</a><span>{{ 'TOPBAR.DEMO.PART3' | translate }}</span></div>
      }@if (isSearchbarEnabled && !settings?.is_demo_enabled) {
      <app-typeahead class="w-50" [isAdvancedSearchEnable]="true" (selectService)="onSelectService($event)" [service]="service" [resourceName]="resourceName" [onMatOptionSelect]="onMatOptionSelect" [instanceId]="'magnifying-search'"></app-typeahead>
    }
    <ul class="navbar-nav ms-auto">
      <li class="nav-item v-nav-item me-2"><a class="nav-link text-center" [routerLink]="['/logout']"><i class="lnr lnr-exit" aria-hidden="true"></i></a></li>
      @if (!isWhiteLabelEnabled && shouldShow('help')) {
        <li class="nav-item v-nav-item me-2" [popover]="helpTemplate" placement="bottom" triggers="click" [outsideClick]="true" containerClass="v-popover-apps">
          <div class="nav-link text-center"><i class="lnr lnr-question-circle" aria-hidden="true"></i></div>
        </li>
      }
      @if (shouldShow('search')) {
        <li class="nav-item v-nav-item me-2">
          <div class="nav-link text-center" (click)="isSearchbarEnabled = !isSearchbarEnabled"><i class="lnr lnr-magnifier" aria-hidden="true"></i></div>
        </li>
      }
      @if (shouldShow('notifications')) {
        <li class="nav-item v-nav-item me-2"><app-announcement-badge></app-announcement-badge></li>
      }
      @if ((settings?.is_reports_downloadable || isRoot) && shouldShow('download')) {
        <li class="nav-item v-nav-item me-2">
          <div class="nav-link text-center" (click)="openModal()"><i class="lnr lnr-download2" aria-hidden="true"></i></div>
        </li>
      }
      @if (shouldShow('apps')) {
        <li class="nav-item v-nav-item me-2" [popover]="appsTemplate" placement="bottom" triggers="click" [outsideClick]="true" containerClass="v-popover-apps">
          <div class="nav-link text-center"><i class="lnr lnr-icons" aria-hidden="true"></i></div>
        </li>
      }
      <li class="nav-item v-nav-item"><a class="nav-link text-center" [routerLink]="['/account/information']" routerLinkActive="active"><i class="lnr lnr-user" aria-hidden="true"></i></a></li>
      @if (companies?.length > 1) {
        <li class="nav-item v-nav-item">
          <div class="btn-group" dropdown="dropdown" placement="bottom right">
            <div class="nav-link text-center d-flex align-items-center justify-content-center" dropdownToggle="dropdownToggle" style="max-height:40px;">
              <div class="company-pill d-flex align-items-center gap-2 px-2 py-1 bg-light rounded-pill shadow-sm">
                <div class="company-picture" [style.background-image]="'url(' + hiringFirm?.logo_url + ')'"></div><span class="company-name text-secondary small">{{ hiringFirm?.name }}</span>
              </div>
            </div>
            <ul class="dropdown-menu dropdown-menu-right" role="menu" *dropdownMenu="">
              @for (c of companies; track c) {
                <li role="menuitem">
                  <div class="dropdown-item" (click)="onChangeCompanies(c.id)" [ngClass]="{ 'list-group-item-active': c.id === hiringFirm.id }"><img class="me-2" width="24" [src]="c.logo_url" /><span>{{ c.label }}</span></div>
                </li>
              }
            </ul>
          </div>
        </li>
      }
      @if (companies?.length === 1) {
        <li class="nav-item v-nav-item">
          <div class="nav-link text-center d-flex align-items-center justify-content-center" style="max-height:40px;">
            <div class="company-pill d-flex align-items-center gap-2 px-2 py-1 bg-light rounded-pill">
              <div class="company-picture" [style.background-image]="'url(' + hiringFirm?.logo_url + ')'"></div><span class="company-name text-secondary small">{{ hiringFirm?.name }}</span>
            </div>
          </div>
        </li>
      }
    </ul>
  </div>
</nav><ng-template #popTemplate="">
<ul class="list-unstyled">
  @if (rows?.length === 0) {
    <li class="nav-item small text-center">{{ 'TOPBAR.NOTIFICATIONS.EMPTY' | translate }}</li>
  }
  @for (a of rows; track trackByFn(a); let last = $last) {
    <li class="nav-item" [ngClass]="{ 'pb-2': !last }">
      <div class="row small">
        <div class="col-8" [innerHTML]="a.description"></div>
        <div class="col-4 text-end">{{ a.created_at | ago }}</div>
      </div>
    </li>
  }
  <li class="nav-item text-end mt-2">
    <div class="d-grid"><button class="btn btn-sm v-btn v-btn-primary" type="button" (click)="getActivities()"><i class="lnr lnr-refresh me-2" aria-hidden="true"></i>{{ 'BUTTONS.REFRESH' | translate : { type : 'activities' } }}</button></div>
  </li>
</ul>
</ng-template><ng-template #appsTemplate="">
@for (a of apps; track a) {
  <div class="v-popover-apps-app d-inline-flex align-items-center" [ngClass]="{ 'v--opacity-50': a.isDisabled }" (click)="goTo(a)">
    <div class="w-100 text-center"><img class="mx-auto d-block" [src]="a.src" width="25" height="25" [alt]="a.label" />
      <div class="mt-2 text-muted small text-capitalize">{{ a.label }}</div>
    </div>
  </div>
}
</ng-template><ng-template #helpTemplate="">
<ul class="list-group list-group-flush">
  <li class="list-group-item list-group-item-action p-2"><a class="nav-link" href="https://vimeo.com/510463975" target="_blank" tooltip="password: vitay2021" container="body">{{ 'TOPBAR.HELP.DEMO_VIDEO' | translate }}</a></li>
  <li class="list-group-item list-group-item-action p-2"><a class="nav-link" href="https://vitay.io/faq/" target="_blank">{{ 'TOPBAR.HELP.FAQ' | translate }}</a></li>
</ul>
</ng-template><app-modals-export [openModal]="openExportModal"></app-modals-export>@if (shouldShow('notifications')) {
<app-announcement-sidebar></app-announcement-sidebar>
}
